import { EnumInterface } from '@/domain/interface/intern/enumvalues/EnumInterface';
import { LinkInterface } from '@/domain/interface/LinkInterface';

export class ToestelClass {
  id?: string;
  fabricatienummer?: string;
  fabricatienummerOnbekend?: boolean;
  nominaalVermogen?: number;
  brandstof?: EnumInterface;
  branderTechnologie?: EnumInterface;
  merk?: string;
  merkOnbekend?: boolean;
  toestelType?: string;
  toestelTypeOnbekend?: boolean;
  ketelType?: EnumInterface;
  bouwjaar?: number;
  bouwjaarOnbekend?: boolean;
  links?: LinkInterface;
  uitgevoerdDoorErkendeTechnicus?: boolean;
  uitvoerenDoorOwnerMogelijk?: boolean;
  brandstofTypeIsGekend?: boolean;
  erkenningsnummer?: string;
  erkendeTechnicusInvulbaar?: boolean;
  showErkendeTechnicusVelden?: boolean;

  constructor(requestObject?: ToestelClass) {
    this.id = requestObject?.id;
    this.fabricatienummer = requestObject?.fabricatienummer;
    this.fabricatienummerOnbekend =
      requestObject?.fabricatienummerOnbekend || false;
    this.nominaalVermogen = requestObject?.nominaalVermogen;
    this.brandstof = requestObject?.brandstof;
    this.branderTechnologie = requestObject?.branderTechnologie;
    this.merk = requestObject?.merk;
    this.merkOnbekend = requestObject?.merkOnbekend || false;
    this.toestelType = requestObject?.toestelType;
    this.toestelTypeOnbekend = requestObject?.toestelTypeOnbekend || false;
    this.ketelType = requestObject?.ketelType;
    this.bouwjaar = requestObject?.bouwjaar;
    this.bouwjaarOnbekend = requestObject?.bouwjaarOnbekend || false;
    this.links = requestObject?.links;
    this.uitgevoerdDoorErkendeTechnicus =
      requestObject?.uitgevoerdDoorErkendeTechnicus;
    this.uitvoerenDoorOwnerMogelijk = requestObject?.uitvoerenDoorOwnerMogelijk;
    this.brandstofTypeIsGekend = requestObject?.brandstofTypeIsGekend;
    this.erkenningsnummer = requestObject?.erkenningsnummer;
    this.erkendeTechnicusInvulbaar = requestObject?.erkendeTechnicusInvulbaar;
    this.showErkendeTechnicusVelden = requestObject?.showErkendeTechnicusVelden;
  }

  get isBrandstofTypeGas(): boolean {
    return (
      this.brandstof?.code === 'AARDGAS' ||
      this.brandstof?.code === 'LPG' ||
      this.brandstof?.code === 'GAS_TYPE_ONBEKEND' ||
      false
    );
  }
}
